import React from 'react';
import QLaptopLogo from 'images/q/q-laptop.webp';
import styles from './loading.scss';

interface IProps {
  full?: boolean;
}

const Loading = ({ full }: IProps) => {
  return (
    <div className={classnames(styles.container, full && styles.full)}>
      <img src={QLaptopLogo} loading="lazy" />
    </div>
  );
};

export default Loading;
export { default as LoadingSpinner } from './LoadingSpinner';
export { default as LoadingDots } from './LoadingDots';
